import { IconButton, Tooltip } from "@mui/material";
import { Page } from "@mb-pro-ui/components";
import { EnhancedTable } from "@mb-pro-ui/components/table";
import { TemplateHelper } from "../utils/types";
import { useCallback, useEffect, useMemo } from "react";
import { Column, Row } from "react-table";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";

import RefreshIcon from "@mui/icons-material/Refresh";
import AddIcon from "@mui/icons-material/Add";
import { useErrorHandler } from "../hooks/useErrorHandler";
import { useMutation } from "react-query";
import { useApi } from "../utils/ApiProvider";
import { usePageSxProps } from "./styles";
import { APP_NAME } from "../App";

export const TemplateHelpersPage = () => {
  const { listPageSx } = usePageSxProps();
  const { formatMessage } = useIntl();
  const history = useHistory();
  const api = useApi();

  // TODO: többi előfordulható hiba
  const { errorHandler: onError } = useErrorHandler([
    [
      { status: 401, type: "template-helper" },
      () => formatMessage({ defaultMessage: "You have no rights for configuration helper management." }),
      () => {
        history.push("/");
      },
    ],
    [{ status: 400 }, () => null],
  ]);

  const listQuery = useCallback(() => api<TemplateHelper[]>("/template-helpers"), [api]);
  const { mutate: getList, data: list, status: queryStatus } = useMutation({ mutationFn: listQuery, onError });

  const columns = useMemo(
    (): Column<TemplateHelper>[] => [
      {
        id: "type",
        Header: formatMessage({
          defaultMessage: "Type",
        }),
        accessor: (item) => item.type,
        width: 50,
      },
      {
        id: "keyRule",
        Header: formatMessage({
          defaultMessage: "Key rule",
        }),
        accessor: (item) =>
          item.keyRule === "all"
            ? formatMessage({ defaultMessage: "All keys" })
            : item.keyRule === "equals"
            ? formatMessage({ defaultMessage: "Equals" })
            : item.keyRule === "startsWith"
            ? formatMessage({ defaultMessage: "Starts with" })
            : item.keyRule,
        width: 50,
      },
      {
        id: "key",
        Header: formatMessage({
          defaultMessage: "Key",
        }),
        accessor: (item) => item.key ?? "",
        width: 50,
      },
      {
        id: "hwtype",
        Header: formatMessage({
          defaultMessage: "Hardware type",
        }),
        accessor: (item) => item.hwtype ?? "",
        width: 50,
      },
      {
        id: "info",
        Header: formatMessage({
          defaultMessage: "Description",
        }),
        accessor: (item) => item.info,
        width: 200,
      },
      {
        id: "lang",
        Header: formatMessage({
          defaultMessage: "Language",
        }),
        accessor: (item) => item.lang,
        width: 50,
      },
    ],
    [formatMessage]
  );

  const newTemplateHelper = useCallback(() => {
    history.push("/template-helpers/new");
  }, [history]);

  const updateTemplateHelpers = useCallback(() => getList(), [getList]);

  useEffect(() => {
    document.title = `${formatMessage({ defaultMessage: "Configuration helpers" })} - ${APP_NAME}`;
  }, [formatMessage]);

  useEffect(() => {
    updateTemplateHelpers();
  }, [updateTemplateHelpers]);

  return (
    <Page sx={listPageSx}>
      <EnhancedTable
        columns={columns}
        data={list ?? []}
        showResultCount
        // getRowProps={rowProps}
        queryStatus={queryStatus}
        overscanCount={5}
        onRowClick={(item: Row<TemplateHelper>) => history.push(`/template-helpers/${item.original.id}`)}
        postfix={
          <>
            <IconButton
              size="small"
              sx={{
                color: "primary.contrastText",
              }}
              onClick={updateTemplateHelpers}
            >
              <Tooltip
                title={formatMessage({
                  defaultMessage: "Reload",
                })}
              >
                <RefreshIcon />
              </Tooltip>
            </IconButton>
            <IconButton
              size="small"
              sx={{
                color: "primary.contrastText",
              }}
              onClick={newTemplateHelper}
            >
              <Tooltip
                title={formatMessage({
                  defaultMessage: "Create new file",
                })}
              >
                <AddIcon />
              </Tooltip>
            </IconButton>
          </>
        }
      />
    </Page>
  );
};

export default TemplateHelpersPage;
